import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RestrictToDirective} from './restrict-to.directive';
import { ClickOutsideDirective } from './click-outside.directive';
import { InputFinishedDirective } from './input-finished.directive';
import {ImageFullyVisibleDirective} from './image-fully-visible.directive';
import {DragFileToBrowserDirective} from './drag-file-to-browser-directive';
import {SocialSecurityInputDirective} from './social-security-input.directive';
import {FocusOnLoadDirective} from './focus-on-load.directive';
import { DateInputDirective } from './date-input.directive';
import { CurrencyFormatterDirective } from './currency-formatter.directive';
import { TdoInputDirective } from './tdo-input.directive';
import { InputDirtyBlurDirective } from './input-dirty-blur.directive';




@NgModule({
  declarations: [
    RestrictToDirective,
    ClickOutsideDirective,
    InputFinishedDirective,
    ImageFullyVisibleDirective,
    DragFileToBrowserDirective,
    SocialSecurityInputDirective,
    FocusOnLoadDirective,
    DateInputDirective,
    CurrencyFormatterDirective,
    TdoInputDirective,
    InputDirtyBlurDirective,

  ],
  imports: [
    CommonModule,
  ],
  exports: [
    RestrictToDirective,
    ClickOutsideDirective,
    InputFinishedDirective,
    ImageFullyVisibleDirective,
    DragFileToBrowserDirective,
    SocialSecurityInputDirective,
    FocusOnLoadDirective,
    DateInputDirective,
    CurrencyFormatterDirective,
    TdoInputDirective,
    InputDirtyBlurDirective,

  ]
})
export class DirectivesModule { }
